<template>
  <div class="membership">
    <memberStaff />
  </div>
</template>

<script>
import memberStaff from '../../components/staff/memberStaff.vue';
export default {
name:"membership",
components:{memberStaff}
}
</script>

<style>

</style>